export default __webpack_public_path__ + "static/media/fauna-indexes-access-later-tip.ac271f5c.png";